<div class="card-primary">
  <p style="text-align: center">
    {{ 'case.confirm-changing-ratingsystem.warning' | translate | capitalize }}
  </p>
  <p style="text-align: center">
    {{ 'case.confirm-changing-ratingsystem.question' | translate | capitalize }}
  </p>
  <button mat-flat-button [mat-dialog-close]="false">
    {{ 'general.words.no' | translate | capitalize }}
  </button>
  <button mat-raised-button style="float: right" color="primary" [mat-dialog-close]="true">
    {{ 'general.words.yes' | translate | capitalize }}
  </button>
</div>
